import { useLocation, useSubmit } from 'react-router-dom';
import React, { useRef } from 'react';
import { RecaptchaFieldHandle } from '@/common/components/RecaptchaField.tsx';

export function useRecaptchaFormSubmit<T>(resetForm: () => void): {
  recaptchaRef: React.RefObject<RecaptchaFieldHandle | null>;
  onSubmit: (data: T) => void;
} {
  const location = useLocation();
  const submit = useSubmit();
  const recaptchaRef = useRef<RecaptchaFieldHandle>(null);

  const onSubmit = (data: T) => {
    const token = recaptchaRef.current?.token;
    if (!token) return;

    void submit(
      {
        ...data,
        recaptcha_token: token,
      },
      {
        method: 'post',
        action: location.pathname,
      }
    );

    resetForm();
    recaptchaRef.current?.reset();
  };

  return { recaptchaRef, onSubmit };
}
